export default __webpack_public_path__ + "static/media/col-image-5_370x450_crop_center.progressive.33492d61.jpg";